import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogAbstractComponent } from '../dialogs/dialog.class';

export interface IdleCountdownData {
  remainingTime: number; // in milliseconds
  onExtend?: () => void;
  onLogout?: () => void;
}

@Component({
  selector: 'app-idle-countdown',
  templateUrl: './idle-countdown.component.html',
  styleUrls: ['./idle-countdown.component.scss'],
})
export class IdleCountdownComponent extends DialogAbstractComponent implements OnInit, OnDestroy {
  data: IdleCountdownData;

  remainingSeconds: number = 0;
  minutes: number = 0;
  seconds: number = 0;
  private destroy$ = new Subject<void>();

  constructor(injector: Injector) {
    super(injector);
    this.data = this.dialogParams;
  }

  ngOnInit() {
    if (this.data) {
      this.remainingSeconds = Math.floor(this.data.remainingTime / 1000);
      this.updateDisplay();
      this.startCountdown();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private startCountdown() {
    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.remainingSeconds--;
        this.updateDisplay();

        if (this.remainingSeconds <= 0) {
          this.onLogout();
          this.destroy$.next(); // Stop the countdown by completing the observable
        }
      });
  }

  private updateDisplay() {
    this.minutes = Math.floor(this.remainingSeconds / 60);
    this.seconds = this.remainingSeconds % 60;
  }

  onExtend() {
    if (this.data?.onExtend) {
      this.data.onExtend();
    }
    this.closeDialog('extend');
  }

  onLogout() {
    if (this.data?.onLogout) {
      this.data.onLogout();
    }
    this.closeDialog('logout');
  }

  getTimeDisplay(): string {
    return `${this.minutes.toString().padStart(2, '0')}:${this.seconds.toString().padStart(2, '0')}`;
  }

  getProgressPercentage(): number {
    const totalTime = Math.floor(this.data.remainingTime / 1000);
    return ((totalTime - this.remainingSeconds) / totalTime) * 100;
  }
}
